import { Close as CloseIcon } from '@mui/icons-material';
import { Box, CircularProgress, Dialog, IconButton, Typography } from '@mui/material';

import * as voiceLib from 'entities/voice/lib';

import { Voices } from 'shared/api';
import { useFileUrl } from 'shared/lib';

type Props = {
  voice: Voices | null;
  onClose: () => void;
};

/** Просмотр аватара в полный размер. Один экземпляр на таблицу, открыт пока voice !== null. */
export const AvatarLightbox = ({ voice, onClose }: Props) => {
  const src = useFileUrl(voiceLib.getAvatarPath(voice?.avatar));

  return (
    <Dialog
      open={!!voice}
      onClose={onClose}
      maxWidth={false}
      aria-labelledby="avatar-lightbox-title"
      PaperProps={{
        sx: { bgcolor: 'transparent', boxShadow: 'none', m: 2, overflow: 'visible' },
      }}
      slotProps={{ backdrop: { sx: { bgcolor: 'rgba(0, 0, 0, 0.85)' } } }}
    >
      <IconButton
        aria-label="Close"
        onClick={onClose}
        sx={{ position: 'fixed', top: 12, right: 12, color: 'common.white' }}
      >
        <CloseIcon />
      </IconButton>

      <Box display="flex" flexDirection="column" alignItems="center" gap={1.5}>
        {src ? (
          <Box
            component="img"
            src={src}
            alt={voice?.name ?? ''}
            sx={{
              maxWidth: 'calc(100vw - 64px)',
              maxHeight: 'calc(100vh - 120px)',
              objectFit: 'contain',
              borderRadius: 1,
              display: 'block',
            }}
          />
        ) : (
          <Box sx={{ width: 240, height: 240, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <CircularProgress sx={{ color: 'common.white' }} />
          </Box>
        )}
        <Typography id="avatar-lightbox-title" variant="subtitle1" sx={{ color: 'common.white' }}>
          {voice?.name}
        </Typography>
      </Box>
    </Dialog>
  );
};
